import { AttributeType } from './attribute-type';

export enum Civil3dPropertyType {
  INTEGER = 'Integer',
  LIST = 'List',
  REAL = 'Real',
  TEXT = 'Text',
  TRUEFALSE = 'TrueFalse',
}

export const civil3dPropertyTypeAttributeTypeMapping: Record<Civil3dPropertyType, AttributeType[]> = {
  [Civil3dPropertyType.INTEGER]: [AttributeType.INTEGER],
  [Civil3dPropertyType.LIST]: [AttributeType.LIST],
  [Civil3dPropertyType.REAL]: [AttributeType.DOUBLE],
  [Civil3dPropertyType.TEXT]: [AttributeType.STRING, AttributeType.FILE, AttributeType.PHOTO, AttributeType.LIST],
  [Civil3dPropertyType.TRUEFALSE]: [],
};
